module.exports = __webpack_public_path__ + "static/media/burger.3e7cefe5.png";